import TextHeader from "./TextHeader"
import TextSubHeader from "./TextSubHeader"

const Text = {
    Header: TextHeader,
    SubHeader: TextSubHeader,
}

export default Text
